import {
    defaultBaseQuery,
    transformErrorResponse,
    transformSuccessResponse
} from '@/services';
import { createApi } from '@reduxjs/toolkit/query/react';

const studentViewApi = createApi({
    baseQuery: defaultBaseQuery,
    reducerPath: 'studentViewApi',
    endpoints: (builder) => ({

        getStudentViewList: builder.query({
            query: ({ page = 0, size = 10, ...params } = {}) => ({
                url: `/sreg/student/records/filter`,
                method: 'GET',
                params: { page, size, ...params }
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        exportStudentViewExcel: builder.query({
            query: (params = {}) => ({
                url: `/sreg/student/records/filter/excel`,
                method: 'GET',
                // page 0 + size 0 = export every matching record, not just one page
                params: { ...params, page: 0, size: 0 },
                responseHandler: async (response) => {
                    const blob = await response.blob();
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = `student_view.xlsx`;
                    a.click();
                    window.URL.revokeObjectURL(url);
                    return { success: true };
                },
                cache: 'no-cache',
            }),
            transformErrorResponse: transformErrorResponse
        }),
    }),
});

export const {
    useLazyGetStudentViewListQuery,
    useLazyExportStudentViewExcelQuery,
} = studentViewApi;

export default studentViewApi;
